const footerFunc = () => {
  /**
   * 展開メニュー
   */
  const targetMenus = document.querySelectorAll('.has-ul');
  targetMenus.forEach(targetMenu => {
    targetMenu.addEventListener('click', () => {
      const subMenu = targetMenu.querySelector('ul');
      targetMenu.classList.toggle('is-active');

      if ( targetMenu.classList.contains('is-active') ) {
        $( subMenu ).slideDown(300);
      } else {
        $( subMenu ).slideUp(300);
      }
    });
  });
}

export default footerFunc;
